export const cancelSubscription = (data, user_id) => {
    return fetch(`/api/v1/customers/${user_id}/deactivate/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
